import { useEffect, useState } from "react";

// Tracks whether the viewport is at or below `breakpoint` (default: Tailwind's `sm`).
// Used to tune chart-internal numeric props (SVG sizing, font sizes) that plain
// CSS breakpoints can't reach.
export default function useIsMobile(breakpoint = 640) {
  const query = `(max-width: ${breakpoint - 1}px)`;
  const [isMobile, setIsMobile] = useState(() => typeof window !== "undefined" && window.matchMedia(query).matches);

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = (e) => setIsMobile(e.matches);
    mql.addEventListener("change", onChange);
    setIsMobile(mql.matches);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);

  return isMobile;
}
